import axios from 'axios'
import {
  S3UploadClient,
  S3UploadParams
} from 'service/protocols/s3-upload/s3-upload-client'

const UPLOAD_TIMEOUT_IN_MS = 120_000

export class S3UploadClientImplementation implements S3UploadClient {
  async upload(params: S3UploadParams): Promise<void> {
    await axios.put(params.url, params.file, {
      headers: { 'Content-Type': params.contentType },
      timeout: UPLOAD_TIMEOUT_IN_MS,
      onUploadProgress: (event) => {
        if (params.onProgress && event.total) {
          params.onProgress(Math.round((event.loaded * 100) / event.total))
        }
      }
    })
  }
}
